var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6655 0H5.33455C2.38836 0 0 2.38837 0 5.33456V26.6655C0 29.6117 2.38836 32 5.33455 32H26.6655C29.6116 32 32 29.6117 32 26.6655V5.33456C32 2.38837 29.6116 0 26.6655 0Z",
    fill: "#E1E1E1",
    fillOpacity: 0.85098
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00073 21.8984H23.0007",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 11.5263V10C12.5007 8.35 13.8507 7 15.5007 7C17.1507 7 18.5007 8.35 18.5007 10V11.5263",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8695 25H11.132C9.2795 25 7.832 23.4663 8.01575 21.7L8.957 12.7C9.11825 11.1662 10.4645 10 12.0733 10H18.932C20.5408 10 21.887 11.1662 22.0483 12.7L22.9895 21.7C23.1732 23.4663 21.7257 25 19.8732 25H19.8695Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAddress);
export default __webpack_public_path__ + "static/media/profile_address.0a37207ea6cb8fee5fce08f26512508f.svg";
export { ForwardRef as ReactComponent };